"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_generatedRepaymentTape = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, loanProductSlug, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `Gen Repayment`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            loanProductSlug,
            creditFacilitySlug: null,
            rawExternalReceivableIdField: '* PLACEHOLDER *',
            rawRepaymentTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('* PLACEHOLDER *'),
            generatedLoanTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('* PLACEHOLDER *'),
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = (0, utils_1.updateArtifactSlug)(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
const REQUIRED_BASE_FIELD_CONFIGS = [
    {
        field: 'finley_repayment_amount',
        type: 'float',
    },
    {
        field: 'finley_repayment_date',
        type: 'date',
    },
    {
        field: 'finley_currency_code',
        type: 'string',
    },
    {
        field: 'finley_valid_repayment',
        type: 'boolean',
    },
];
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const errors = (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => uiNode.isOperation && uiNode.operationType === 'tapebuilder_postSanitize',
        getUINode,
        minInputs: 1,
        maxInputs: 1,
        // This node can be connected to BBR or can be final node.
        // either way synthetic process will insert InternalRepaymentTape
        // node after this one.
        minOutputs: 0,
        // Currently limiting to 1 output, can revisit this as needed when we want
        // single input tape to contribute to multiple outputs
        maxOutputs: 1,
    });
    const allArtifactSlugs = new Set();
    for (const graphNode of graph.nodes) {
        const uiNode = getUINode(graphNode);
        if (!uiNode.isOperation) {
            const nodeArtifactSlug = uiNode.getArtifactSlug(graphNode);
            allArtifactSlugs.add(nodeArtifactSlug);
        }
    }
    const configuredSlugs = [
        node.configuration.rawRepaymentTapeArtifactSlug,
        node.configuration.generatedLoanTapeArtifactSlug,
    ];
    configuredSlugs.forEach((slug) => {
        if (!allArtifactSlugs.has(slug)) {
            errors.push(`"${slug}" artifactSlug does not exist in graph`);
        }
    });
    return errors;
};
// validate given IntermediateRecord.
// this is called after initialial Config validation is done
// and the intermediate record is generated.
// here an instance of ITapeBuilder is available, which can be used
// to inspect any Tape definitions.
const validateIntermediateTape = (input) => {
    const { tape, tapeBuilder } = input;
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    const { id, artifactSlug } = tape;
    const configErrors = [];
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(id);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, `generated repaymentTape tapeDefinition for ${artifactSlug} is not valid`);
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, `generated repaymentTape tapeDefinition for ${artifactSlug} is null`);
    const { baseFields } = tapeDefinitionResult.data;
    REQUIRED_BASE_FIELD_CONFIGS.forEach((requiredField) => {
        const { field, type } = requiredField;
        const baseField = baseFields.find(({ field: f }) => f === field);
        if (!baseField) {
            configErrors.push(`validateIntermediateTape: [${artifactSlug}] is expected to have [${field}]`);
        }
        else if (baseField.type !== type) {
            configErrors.push(`validateIntermediateTape: [${artifactSlug}] has [${field}] of type [${baseField.type}] but expected [${type}]`);
        }
    });
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_generatedRepaymentTape = {
    // what should node say on the tape-builder node creation menu.
    nodeTypeText: 'Generated Repayment',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    badgeTexts: ['Generated', 'Repayment'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map